import React, { useState, useEffect } from 'react'
// import styled from '@emotion/styled'
import './styles/style.css'
import Layout from './components/Layout'
import LatestNews from './components/LatestNews'
// import HealthData from './components/HealthData/Index'
import AboutUs from './components/AboutUs'

import { Route, Routes } from 'react-router-dom'
import CurrentNews from './components/CurrentNews'
import Settings from './components/Settings'
import Register from './components/Register'
import Cookies from 'js-cookie'
// import HtmlEditor from './components/HtmlEditor'
import axios from 'axios'
import MetabolicPlan from './components/MetabolicPlan/Index'
import Warning from './components/Warning'
import HaAppQrcode from './components/HaAppQrcode'
import PatientData from './components/PatientData/Index'
import PatientDetail from './components/Patient/PatientDetail'
import DataCollection from './components/DataCollection'
import DKABioReport from './components/Patient/DKABioReport'

import { AuthContext } from './components/AuthContext'
// import { Alert } from 'react-bootstrap'
// import { ProgressBar } from 'react-bootstrap'

// import Login from './components/Login'

function MainApp() {
  const [currentUser, setCurrentUser] = useState(null)
  const [loginShow, setLoginShow] = useState(false)
  // 保留連結重新導向
  const [redirectTo, setRedirectTo] = useState(null)
  // 30 分鐘
  const expiresTime = parseFloat(process.env.REACT_APP_EXPIRES_TIME)
  const cookieOptions = { expires: expiresTime, secure: true }
  // 警告
  const [warning, setWarning] = useState({
    show: false,
    msg: '',
    confirmMsg: '',
    onConfirm: () => {},
    onCancel: () => {},
    isLoading: false,
  })
  const [qrcode, setQrcode] = useState({ show: false, msg: '' })
  const [isLoading, setIsLoading] = useState(false)
  const baseUrl = process.env.REACT_APP_BASE_URL

  // 設置 cookie
  const setCookie = (name, value, options = {}) => {
    Cookies.set(name, value, { ...options, secure: true })
  }
  // 獲取 cookie
  const getCookie = (name) => Cookies.get(name)

  // 刪除 cookie
  const removeCookie = (name) => Cookies.remove(name)

  async function sendDiscordNotification(message) {
    try {
      await axios.post('/api/send-notification', {
        content: message,
      })
    } catch (error) {
      console.error('Failed', error)
    }
  }

  // 延長 cookie 過期的時間
  function extendCookie() {
    if (Cookies.get('session')) {
      const getUser = JSON.parse(Cookies.get('session'))
      Cookies.set('session', JSON.stringify(getUser), cookieOptions)
    }
  }

  // 檢查是否是第一次訪問
  const checkFirstVisit = () => {
    if (!getCookie('visited')) {
      setCookie('visited', 'true', { expires: 365 }) // 設置為一年有效期
      return true
    }
    return false
  }

  // 處理登入邏輯
  const handleLoginStatus = () => {
    const sessionCookie = getCookie('session')
    const isFirstVisit = checkFirstVisit()

    if (!sessionCookie) {
      if (isFirstVisit) {
        console.log('第一次訪問網站')
        return { status: 'first_visit', user: null }
      } else {
        console.log('登入已逾時，請重新登入')
        return { status: 'login_expired', user: null }
      }
    } else {
      try {
        const user = JSON.parse(sessionCookie)
        console.log('正常登入狀態')
        return { status: 'logged_in', user }
      } catch (error) {
        console.error('Session cookie 解析錯誤', error)
        removeCookie('session')
        return { status: 'error', user: null }
      }
    }
  }

  useEffect(() => {
    const { status, user } = handleLoginStatus()

    switch (status) {
      case 'first_visit':
        // 處理第一次訪問的邏輯
        break
      case 'login_expired':
        alert('登入已逾時，請重新登入')
        setLoginShow(true)
        break
      case 'logged_in':
        setCurrentUser(user)
        break
      case 'error':
        alert('發生錯誤，請重新登入')
        setLoginShow(true)
        break
      default:
        break
    }
  }, [])

  useEffect(() => {
    console.log('loginShow', loginShow)
  }, [loginShow])

  return (
    <div className="App">
      {warning.show && <Warning setWarning={setWarning} warning={warning} />}
      {qrcode.show && <HaAppQrcode qrcode={qrcode} setQrcode={setQrcode} />}
      <AuthContext.Provider
        value={{
          baseUrl,
          sendDiscordNotification,
          currentUser,
          isLoading,
          setIsLoading,
          extendCookie,
          setLoginShow,
        }}
      >
        <Routes>
          {/* <Route path="/ha-faq" element={<HaFaq />} /> */}
          <Route
            path="/"
            element={
              <Layout
                currentUser={currentUser}
                setCurrentUser={setCurrentUser}
                loginShow={loginShow}
                setLoginShow={setLoginShow}
                redirectTo={redirectTo}
                setRedirectTo={setRedirectTo}
                sendDiscordNotification={sendDiscordNotification}
              />
            }
          >
            <Route
              path="/"
              element={
                <LatestNews
                  currentUser={currentUser}
                  setLoginShow={setLoginShow}
                  setRedirectTo={setRedirectTo}
                  extendCookie={extendCookie}
                />
              }
            />

            <Route
              path="/currentNews/:newsId"
              element={
                <CurrentNews
                  currentUser={currentUser}
                  extendCookie={extendCookie}
                  sendDiscordNotification={sendDiscordNotification}
                />
              }
            />

            {Cookies.get('session') && (
              <>
                {/* <Route
                  path="/health-data"
                  element={
                    <HealthData
                      currentUser={currentUser}
                      setCurrentUser={setCurrentUser}
                      loginShow={loginShow}
                      setLoginShow={setLoginShow}
                    />
                  }
                /> */}

                <Route
                  path="/metabolic-plan"
                  element={
                    <MetabolicPlan
                      currentUser={currentUser}
                      warning={warning}
                      setWarning={setWarning}
                      qrcode={qrcode}
                      setQrcode={setQrcode}
                    />
                  }
                />

                <Route
                  path="/patient-data"
                  element={
                    <PatientData
                      warning={warning}
                      setWarning={setWarning}
                      qrcode={qrcode}
                      setQrcode={setQrcode}
                      setLoginShow={setLoginShow}
                    />
                  }
                />

                <Route
                  path="/patient/:patient_id"
                  element={<PatientDetail />}
                />

                <Route
                  path="/patient/:patient_id/data-collection"
                  element={<DataCollection />}
                />
                <Route
                  path="/patient/:patient_id/dkabio-report"
                  element={<DKABioReport />}
                />

                <Route
                  path="/settings"
                  element={
                    <Settings
                      currentUser={currentUser}
                      setCurrentUser={setCurrentUser}
                      setLoginShow={setLoginShow}
                      sendDiscordNotification={sendDiscordNotification}
                    />
                  }
                />
              </>
            )}

            <Route path="/aboutUs" element={<AboutUs />} />

            {Cookies.get('session') || (
              <Route
                path="/register"
                element={
                  <Register sendDiscordNotification={sendDiscordNotification} />
                }
              />
            )}

            {/* <Route path="/html-editor" element={<HtmlEditor />} /> */}

            {/* 404就去home */}
            <Route
              path="*"
              element={
                <LatestNews
                  currentUser={currentUser}
                  setLoginShow={setLoginShow}
                  setRedirectTo={setRedirectTo}
                  extendCookie={extendCookie}
                  sendDiscordNotification={sendDiscordNotification}
                />
              }
            />
          </Route>
        </Routes>
      </AuthContext.Provider>
    </div>
  )
}

export default MainApp
